import { navigate } from 'gatsby';
import { getUserType, setAuthCookies, removeAuthCookies } from './cookie-utils';
import { removeAcl, getAcl } from './acl-utils';
import {
  webSocketConnection,
  isAliveWebSocket
} from '../../common/webSocket/WebSocket';
import { socketData } from '../../common/webSocket/webSocketData';

const connectScoket = (id, token, username, userType) => {
  let socket = new webSocketConnection();
  socket.connect(socketData({ socketInstance: socket, token: token }));
};

export const setToken = async (
  { id, token, username, userType },
  routeTo = '/app/dashboard'
) => {
  if (!isAliveWebSocket()) {
    connectScoket(id, token, username, userType);
  }
  setAuthCookies({ id, token, username, userType });
  //TODO: navigate(routeTo)
};
export const removeAllLocStorage = async () => {
  await localStorage.clear();
  return true;
};

export const logout = ({ routeTo = '/', shouldRedirect = true } = {}) => {
  // localStorage.removeItem('userData');
  removeAllLocStorage();
  window.localStorage.setItem('logout', Date.now()); // Log out from all windows
  if (shouldRedirect) {
    const userType = getUserType();
    if (userType == 0) navigate(routeTo);
    else navigate('/');
    removeAuthCookies();
    removeAcl();
    return true;
  }
};
